import { Button as TomatoButton, ThemeProvider as TomatoProvider } from '@change/ds-core-ui';
import type { ButtonProps as TomatoButtonProps } from '@change/ds-core-ui';

import { Button as SunriseButton, ThemeProvider } from '@change/ds-core-ui/next';
import type { ButtonProps } from '@change/ds-core-ui/next';

import { useIsSunriseEnabled } from '../../../../../hooks/isSunriseEnabled';

export const Button = ({ children, ...props }: ButtonProps) => {
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<>
			{isSunriseEnabled ? (
				<ThemeProvider data-qa="sunrise-provider">
					<SunriseButton {...props}>{children}</SunriseButton>
				</ThemeProvider>
			) : (
				<TomatoProvider data-qa="tomato-provider">
					<TomatoButton {...(props as TomatoButtonProps)}>{children}</TomatoButton>
				</TomatoProvider>
			)}
		</>
	);
};
